export default __webpack_public_path__ + "static/Tek_Fence_Support-febb2981fc5056a1bf9a78b81f702408.png";